import React from 'react';
import PropTypes from 'prop-types';
import { Button, Flex } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../../../../knock-design-system';
import HoursListItem from './HoursListItem';
import {
  ADD_HOLIDAY_HOURS_LABEL,
  DAYS_OF_THE_WEEK,
  dayHoursPropType,
} from './constants';
import { HOURS_TABS } from '../constants';

const useCss = makeCss({
  holidayButton: {
    flexShrink: 0,
  },
});

const HoursList = ({ hours, onAddHolidayHours, selectedTab, updateHours }) => {
  const css = useCss();
  const weeklyHours = hours[selectedTab] || {};

  const isAddHolidayHoursVisible =
    selectedTab === HOURS_TABS.OFFICE || selectedTab === HOURS_TABS.TOURING;

  const handleDayChange = (day) => (updates) => {
    updateHours(selectedTab, day, updates);
  };

  const handleAddHolidayHoursForDay = (day) => () => {
    onAddHolidayHours(selectedTab, day);
  };

  return (
    <Flex flexDirection="column" gap={16}>
      {DAYS_OF_THE_WEEK.map((day) => (
        <HoursListItem
          day={day}
          dayHours={weeklyHours[day]}
          key={day}
          onChange={handleDayChange(day)}
        >
          {isAddHolidayHoursVisible && (
            <Button
              css={css.holidayButton}
              onClick={handleAddHolidayHoursForDay(day)}
              variant="text"
            >
              {ADD_HOLIDAY_HOURS_LABEL}
            </Button>
          )}
        </HoursListItem>
      ))}
    </Flex>
  );
};

HoursList.propTypes = {
  hours: PropTypes.objectOf(PropTypes.objectOf(dayHoursPropType)).isRequired,
  onAddHolidayHours: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
  updateHours: PropTypes.func.isRequired,
};

export default HoursList;
